
import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { ThemeContext } from '../context/ThemeContext';
import { content } from '../content';

const About = () => {
  const { language } = useContext(LanguageContext);
  const { theme } = useContext(ThemeContext);
  const aboutContent = content[language].about;

  const textClasses = theme === 'dark' ? 'text-gray-300' : 'text-gray-700';

  return (
    <section id="about" className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-gray-900' : 'bg-white'}`}>
      <div className="container mx-auto">
        <h2 className={`text-3xl md:text-4xl font-extrabold text-center mb-10 md:mb-12 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>{aboutContent.title}</h2>
        <div className="max-w-4xl mx-auto">
            <p className={`text-base md:text-lg mb-6 ${textClasses}`}>{aboutContent.paragraph1}</p>
            <p className={`text-base md:text-lg mb-6 ${textClasses}`}>{aboutContent.paragraph2}</p>
            <p className={`text-base md:text-lg mb-6 ${textClasses}`}>{aboutContent.paragraph3}</p>
            <p className={`text-base md:text-lg ${textClasses}`}>{aboutContent.paragraph4}</p>
        </div>
      </div>
    </section>
  );
};

export default About;
